import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedContent } from '@shared/services/content/content-jsons/shared-content';
import { ButtonModule } from '@vg-constellation/angular-18/button';

@Component({
  selector: 'app-footer-nav',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './footer-nav.component.html',
  styleUrls: ['./footer-nav.component.scss'],
})
export class FooterNavComponent {
  @Input() continueLabel = SharedContent.buttons.continueButton;
  @Output() backClicked = new EventEmitter<void>();
  @Output() continueClicked = new EventEmitter<void>();

  content = SharedContent;

  onBack(): void {
    this.backClicked.emit();
  }

  onContinue(): void {
    this.continueClicked.emit();
  }
}
